export const plans = Object.freeze({
  free: {
    id: "free",
    name: "Başlangıç",
    maxAthletes: 5,
    features: ["athletes", "attendance", "measurements"]
  },
  coachPro: {
    id: "coachPro",
    name: "Antrenör Pro",
    maxAthletes: 50,
    features: [
      "athletes",
      "attendance",
      "measurements",
      "workouts",
      "races",
      "raceResults",
      "parentSummaries"
    ]
  },
  club: {
    id: "club",
    name: "Kulüp",
    maxAthletes: 500,
    features: [
      "athletes",
      "attendance",
      "measurements",
      "workouts",
      "races",
      "raceResults",
      "parentSummaries",
      "multipleCoaches",
      "advancedReports"
    ]
  }
});

export function resolveEntitlements(subscription) {
  const usableStatuses = ["trialing", "active"];
  const planId = subscription && usableStatuses.includes(subscription.status)
    ? subscription.planId
    : "free";
  const plan = plans[planId] || plans.free;
  return {
    ...plan,
    status: subscription?.status || "free",
    trialEndsAt: subscription?.trialEndsAt || null
  };
}

export function hasFeature(entitlements, feature) {
  return entitlements.features.includes(feature);
}

export function canAddAthlete(entitlements, athleteCount) {
  return athleteCount < entitlements.maxAthletes;
}
